import { createFeatureSelector } from '@ngrx/store';
import { verificationData } from '../reducers/verification.reducers';

export const selectVerification = createFeatureSelector(verificationData);
